import {
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Select as SelectWrapper,
} from "../ui";
import { OptionProps } from "./types";

const Select = ({ options, onChange, placeholder, value, ...rest }: any) => {
  return (
    <SelectWrapper onValueChange={onChange} value={value} {...rest}>
      <SelectTrigger className="w-full h-[40px]">
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className="max-h-48 overflow-auto">
        {options?.length ? (
          options?.map((option: OptionProps) => (
            <SelectItem
              value={option.value}
              disabled={option?.disabled || false}
            >
              {option.label}
            </SelectItem>
          ))
        ) : (
          <SelectItem value="no_data">No Data</SelectItem>
        )}
      </SelectContent>
    </SelectWrapper>
  );
};

export default Select;
